
import {
  inject, observer,
} from 'mobx-react';
import React, {
  Component,
} from 'react';
import GeneralSearchComponent from '../../components/GeneralCRUDComponent/GeneralSearchComponent/GeneralSearchComponent';
import GeneralTableComponent from '../../components/GeneralCRUDComponent/GeneralTableComponent/GeneralTableComponent';
import {
  TableCellTypes,
} from '../../components/GeneralCRUDComponent/TableCellTypes/TableCellTypes';
import {
  translate,
} from '../../helperFunctions/translation';
import {
  IStatisticsStore, User,
} from '../../mobx-store/storeInterfaces/statisticsInterface';
import styles from './statistics.module.scss';
import AlertDialog from '../../components/Dialog/alertDialog';
import { AuthStore } from '../../mobx-store/stores/authStore';
import SnackBarComponent from '../../components/SnackBarComponent/SnackBarComponent';

interface IProps {
  history?: any;
  statisticsStore: IStatisticsStore;
  authStore: AuthStore;
}

interface IState {
  pageNumber: number;
  totalNumberOfPages: number;
  pageSize: number;
  openSuspend: boolean;
  openUnSuspend: boolean;
  searchTitle: string;
  isSuspended: boolean;
}

@inject('statisticsStore')
@inject('authStore')
@observer
class suspendedUsers extends Component<IProps, IState> {
  tableHeader: any = [];

  UserData: any[] = [];

  tableCellTypes: TableCellTypes[] = [];

  constructor(props: IProps) {
    super(props);
    this.state = {
      pageNumber: 1,
      totalNumberOfPages: 1,
      pageSize: 50,
      openSuspend: false,
      openUnSuspend: false,
      searchTitle: '',
      isSuspended: true,
    };
  }
  
  async componentWillMount(){
      await this.getUsers(this.state.isSuspended);
  }

  getRegisteredUserTableHeader = () => [
    {
      title: translate('statisticsListNameColumnTitle'),
    },
    {
      title: translate('statisticsListMemberShipColumnTitle'),
    },
    {
      title: translate('statisticsListPhoneNumberColumnTitle'),
    },
    {
      title: translate('SuspendedStatus'),
    },
    {
      title: translate('action'),
    },
  ];

  getRegisteredUserTableData = () => this.props.statisticsStore.usersList.map((user: User) => ({
    ...user,
    status: user.isSuspended ? translate('Suspended') : translate('UnSuspended'),
    isSuspended: user.isSuspended ? translate('UnSuspend') : translate('Suspend'),

  }));
;

  getRegisteredUserTableCellTypes = (): TableCellTypes[] => [
    {
      cellType: 'Text',
      key: 'firstName',
    },
    {
      cellType: 'Text',
      key: 'membershipId',
    },
    {
      cellType: 'Text',
      key: 'phoneNumber',
    },
    {
      cellType: 'Text',
      key: 'status',
    },
    {
      cellType: 'Button',
      key: 'isSuspended',
      onClick: this.handleTableToggleCellChange,
    },
  ];

  asyncSetState = async<K extends keyof IState>(state: Pick<IState, K>) => new Promise((res) => {
    this.setState({
      ...state,
    }, () => res());
  });

  leftArrowClicked = async () => {
    await this.asyncSetState({
      pageNumber: this.state.pageNumber - 1,
    });
    await this.getUsers(this.state.isSuspended);
  };

  rightArrowClicked = async () => {
    await this.asyncSetState({
      pageNumber: this.state.pageNumber + 1,
    });
    await this.getUsers(this.state.isSuspended);
  };

  setTotalPagesNumber = async (totalNumber: number) => {
    const numberOfPages = Math.ceil(
      totalNumber / this.state.pageSize,
    );
    await this.asyncSetState({
      totalNumberOfPages: numberOfPages,
    });
  };

  async getUsers(isSuspended =false){
    await this.props.statisticsStore.getAllUsers(this.state.pageNumber, this.state.pageSize, false, this.state.searchTitle, isSuspended);
    this.setTotalPagesNumber(this.props.statisticsStore.numberOfUsers);
  }
  handleClickOpenUnSuspend = () => {
    this.setState({
      openUnSuspend: true,
    });
  };

  handleSearchChanged = async (title: string) => {
    this.setState({
      searchTitle: title,
      isSuspended: title ? false : true,
    });
    await this.getUsers(this.state.isSuspended);
  };

  handleClickOpenSuspend = () => {
    this.setState({
      openSuspend: true,
    });
  };

  handleClose = () => {
    this.setState({
      openSuspend: false,
      openUnSuspend: false,
    });
  };
  handleAgreeSuspend = () => {
  };

  handleAgreeUnSuspend = () => {
  };

  handleTableToggleCellChange = async (index: number, key: string) => {
    if(!this.props.statisticsStore.usersList[index].isSuspended){
      this.handleClickOpenSuspend();
      this.handleAgreeSuspend = () => {
        this.props.authStore.suspendUser(this.props.statisticsStore.usersList[index].membershipId)
          .then(async () => {
            SnackBarComponent.getInstance().openSnackbar(translate('updatedMessage', {
            }), 8000, 'success');
            await this.getUsers(this.state.isSuspended);
          })
          .catch((error: any) => {
            SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {
            }), 8000, 'error');
          });
        this.setState({
          openSuspend: false,
        });
      }; 
    }else{
      this.handleClickOpenUnSuspend();
      this.handleAgreeUnSuspend = () => {
        this.props.authStore.unsuspendUser(this.props.statisticsStore.usersList[index].membershipId)
          .then(async() => {
            SnackBarComponent.getInstance().openSnackbar(translate('updatedMessage', {
            }), 8000, 'success');
            await this.getUsers(this.state.isSuspended);
          })
          .catch((error: any) => {
            SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {
            }), 8000, 'error');
          });
        this.setState({
          openUnSuspend: false,
        });
      };
    }
  };

  render() {
    this.tableHeader = this.getRegisteredUserTableHeader();
    this.UserData = this.getRegisteredUserTableData();
    this.tableCellTypes = this.getRegisteredUserTableCellTypes();
    return (
      <div className={styles.generalContainer}>
          <GeneralSearchComponent
            onSearchClick={this.handleSearchChanged}
            searchBy="title"
          />
        <div>
         <GeneralTableComponent
            emptyMessage={translate('emptyTable')}
            tableHeader={this.tableHeader}
            tableData={this.UserData}
            tableCellTypes={this.tableCellTypes}
            loading={this.props.statisticsStore.loading}
            hadPagination
            paginationAction={{
              handleClickLeftArrow: this.leftArrowClicked,
              handleClickRightArrow: this.rightArrowClicked,
              pageNumber: this.state.pageNumber,
              totalNumberOfPages: this.state.totalNumberOfPages,
            }}
          />
          <AlertDialog
            title="Suspend User"
            content="are you sure you want to suspend User ?"
            isOpen={this.state.openSuspend}
            agree={this.handleAgreeSuspend}
            disAgree={this.handleClose}
            hasActions
          />
          <AlertDialog
            title="unsuspend User"
            content="are you sure you want to unsuspend User ?"
            isOpen={this.state.openUnSuspend}
            agree={this.handleAgreeUnSuspend}
            disAgree={this.handleClose}
            hasActions
          />

        </div>
      </div>
    );
  }
}

export default suspendedUsers;
